// extracted by mini-css-extract-plugin
export var bottomContent = "pageFooter-module--bottomContent--2a73c";
export var container = "pageFooter-module--container--57ebd";
export var footerItem = "pageFooter-module--footerItem--3a859";
export var linkList = "pageFooter-module--linkList--444ca";
export var mainContent = "pageFooter-module--mainContent--12e29";
export var someLinks = "pageFooter-module--someLinks--f90cc";